<template>
  <div class="wrapper">
    <div v-html="content" :class="getClass" class="wrapper__content" ref="content"></div>
    <div v-if="isDivided" @click.stop="toggleCollapsibleState()" class="wrapper__button">{{moreButtonTitle}}</div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import StrategyTab from './StrategyTab'

const NON_DIVIDED_BLOCK_MAX_HEIGHT = 220
/**
 * Component for render HTML content
 * Used in {@link StrategyTab}, Content Brief Notes block
 */
export default {
  name: 'HtmlRendererComponent',
  mounted () {
    this.$nextTick(function () {
      this.isDividedLocal = this.$refs.content && this.$refs.content.clientHeight > NON_DIVIDED_BLOCK_MAX_HEIGHT
    })
  },
  props: {
    content: {
      type: String,
      required: true
    },
    splittable: {
      type: Boolean,
      defaults: false
    },
    isStaticView: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    content: {
      handler () {
        this.$nextTick(() => {
          const links = this.$refs.content.querySelectorAll('a')
          for (const link of links) {
            link.target = '_blank'
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isDivided () {
      return this.splittable && this.isDividedLocal && !this.isStaticView
    },
    moreButtonTitle () {
      return this.isCollapsed ? 'show more' : 'show less'
    },
    getClass () {
      return this.isDivided && this.isCollapsed ? 'wrapper__content_less' : 'wrapper__content_more'
    }
  },
  methods: {
    toggleCollapsibleState: function () {
      this.isCollapsed = !this.isCollapsed
    }
  },
  data () {
    return {
      isCollapsed: true,
      isDividedLocal: false
    }
  }
}
</script>

<style scoped lang="scss">

  .wrapper {
    &__content {
      overflow: hidden;

      &_more {
        height: auto;
        padding: 24px 30px 30px 30px;
      }

      &_less {
        height: 120px;
        padding: 24px 30px 0 30px;
      }
    }

    &__button {
      height: 60px;
      line-height: 60px;
      font-size: 10px;
      font-weight: 900;
      color: $rfx-light-grey;
      text-transform: uppercase;
      border-top: 2px solid $rfx-almost-white;
      text-align: center;
      cursor: pointer;
    }
  }

</style>
